module.exports = {
  SERVICE_WORKER_VERSION: 15,
  DEFAULT_IMAGE_META: '//st1.trov.it/images/new/homes/logo_normal.png',
};



// WEBPACK FOOTER //
// ./app/constants.js